module.exports = __webpack_public_path__ + "img/banner3.3aab128b.png";